import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { S3UploadPolicy } from '../Documents/DocumentApi.ts';
import { IFacilityInvitationPdfs } from '../../entities/FacilityInvitationPdfs/FacilityInvitationPdfs.ts';

export class FacilityInvitationPdfsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HealthcareFacilities`;

    public static async getByFacility(facilityId: number): Promise<IFacilityInvitationPdfs> {
        return this.sendApiRequest<IFacilityInvitationPdfs>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/${facilityId}/InvitationPdf`,
        });
    }

    public static async getUploadUrl(
        facilityId: number,
        language: string,
        filename: string,
    ): Promise<S3UploadPolicy> {
        return this.sendApiRequest<S3UploadPolicy>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/${facilityId}/InvitationPdf/UploadUrl/${language}/${filename}`,
        });
    }

    public static async remove(
        facilityId: number,
        language: string,
        filename: string,
    ): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: `${this.baseApiUrl}/${facilityId}/InvitationPdf/${language}/${encodeURIComponent(filename)}`,
        });
    }
}
